import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Tabs from "../constants/tabs";

export interface createTabState {
  activeTab: Tabs;
}

const initialState: createTabState = {
  activeTab: Tabs.Home,
};

export const createTabSlice = createSlice({
  name: "activeTab",
  initialState,
  reducers: {
    setTab: (state, action: PayloadAction<Tabs>) => {
      state.activeTab = action.payload;
    },
    resetTabState: () => initialState,
  },
});

export const { setTab, resetTabState } = createTabSlice.actions;

export default createTabSlice.reducer;
